/*
 * Title: Auth/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description:
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React from "react";
import { connect } from "react-redux";
import Step2 from "@containers/creator/Signup/Step2";
import Step3 from "@containers/creator/Signup/Step3";
import Signin from "@containers/creator/Signin";

type Props = {
  form: Object;
  addForm: (form: Object) => void;
};
type MyState = {};

class Signup extends React.Component<Props | any, MyState> {
  componentDidMount = () => {
    let currentUrl = window.location.pathname;
    if (currentUrl === "/signup") {
      const timer = setTimeout(() => {
        this.props.addForm({});
      }, 200);
      return () => clearTimeout(timer);
    }
  };

  render() {
    return (
      <div className="bg-[#F6F2E9] overflow-hidden h-full lg:min-h-screen min-h-[100vh] lg:max-h-[100vh] max-h-[100vh] relative">
        {/*Welcome to Encore section started*/}

        <Signin />

        <Step2 />

        <Step3  />

      </div>
    );
  }
}

const mapStateToProps = ({ user }, ownProps) => {
  return {
    step: user.step,
  };
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
  const { dispatch } = dispatchProps;
  const { actions } = require("@redux/UserRedux");
  return {
    ...stateProps,
    addForm: (form: Object) => {
      dispatch(actions.addForm(form));
    },
    addFormStep: (step: number) => {
      dispatch(actions.addFormStep(step));
    },
  };
};

export default connect(mapStateToProps, undefined, mergeProps)(Signup);
